import type {
    WordId,
    SentenceId,
    ImgNr,
    SentenceWord,
    Index,
    Translation,
} from "$lib/classes/data/_primitives";

export class PunctMark {
    constructor(
        readonly pmark: string
    ) {}
}

// TODO in prod id/t/i should never be null!
export class WordLink {
    constructor(
        public word: SentenceWord,
        public id: WordId | null,
        public t: Translation | null,
        public i: Index | null,
    ) {}
}

export type SentencePart = WordLink | PunctMark;

export class Sentence {
    constructor(
        public readonly id: SentenceId,
        public parts: SentencePart[],
        public imgNr: ImgNr | null,
        public t: Translation | null,
    ) {}

    // TODO TEST !!!
    static sortByIndex(sentences: Sentence[], wordId: WordId) {
        return sentences.sort((s1, s2) => {
                const wL1 = s1.wordLinksWithId(wordId)[0]
                const i1 = wL1.i
                const wL2 = s2.wordLinksWithId(wordId)[0]
                const i2 = wL2.i

                if (i1 === null && i2 !== null) {
                    return 1
                } else if (i1 !== null && i2 === null) {
                    return -1
                } else if (i1 === null && i2 === null) {
                    return 0
                } else {
                    // @ts-ignore
                    return i1 - i2
                }
            }
        )
    }

    get sentence(): string {
        return this.parts.map(part => {
            if (part instanceof WordLink) {
                return part.word;
            } else {
                return part.pmark;
            }
        }).join('')
    }

    get wordLinks(): WordLink[] {
        return this.parts.filter(part => part instanceof WordLink);
    }

    wordLinksWithId(id: WordId): WordLink[] {
        return this.wordLinks.filter(wordLink => wordLink.id === id);
    }

    // TODO TEST !!!
    countOccurence(wordLink: WordLink) {
        const wordLinkId = wordLink.id
        if (wordLinkId === null) return 0
        //TODO refactor to .filter() ?
        return this.wordLinks.reduce((sum, wL) => {
            let partId = wL.id
            if (partId === wordLinkId) {
                sum += 1
            }
            return sum
        }, 0)
    }

    deletePart(index: number) {
        this.parts.splice(index, 1);
    }
}